import { ICorporateLocation, ICorporateLocationAutocomplete } from 'corporate/types';

export const CorporateLocationHelper = {
  isSales: (location: ICorporateLocation, isAlternateVersionEnabled: boolean): boolean => {
    return Boolean(isAlternateVersionEnabled ? +location.isAlternateSales : +location.isSales);
  },

  isShipping: (location: ICorporateLocation, isAlternateVersionEnabled: boolean): boolean => {
    return Boolean(
      isAlternateVersionEnabled ? +location.isAlternateShipping : +location.isShipping
    );
  },

  /**
   * Picks the first shipping-enabled candidate, in priority order, as an autocomplete value.
   * Quote-sourced locations arrive from a SQL CONCAT with string scalars, so the id is coerced —
   * the location autocomplete matches its options by numeric id.
   */
  getDefaultShipping: (
    locations: ICorporateLocation[],
    isAlternateVersionEnabled: boolean
  ): Partial<ICorporateLocationAutocomplete> | null => {
    const location = locations?.find(
      (item) => item?.id && CorporateLocationHelper.isShipping(item, isAlternateVersionEnabled)
    );

    if (!location) {
      return null;
    }

    return { id: Number(location.id), name: location.name };
  },
};
